// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"59":"ef6419bc1d2fba0799df","925":"90d0a321a410105c1a0f"}[chunkId] + ".bundle.js";
};